import { z } from "zod";
import { SystemEntity } from "@erp/shared-types";
import { defineStepConfig } from "../../../registry/helpers";
import { entityOfType } from "../../../utils/system-entities";
import { remittanceProvenanceSchema } from "./remittance-schemas";

/**
 * Build Email Remittance Provenance
 *
 * Reads the inbound email (and the document being processed, for its file
 * name) and emits the source-neutral provenance `create_pending_payment`
 * records the remittance advice from: channel `email`, the Graph/Internet
 * message id (suffixed `#<file name>` per attachment) as raw reference, the
 * email's arrival time, and its sender.
 */
export const buildEmailRemittanceProvenanceStep = defineStepConfig({
  type: "build_email_remittance_provenance",
  name: "Build Email Remittance Provenance",
  description:
    "Describe where an emailed remittance came from (channel, raw reference, received time, sender) for create_pending_payment",
  category: "Data Access",
  libraryModule: "AccountsReceivable",
  inputSchema: z.object({
    inboundEmail: entityOfType(SystemEntity.INBOUND_EMAIL).describe(
      "The inbound email the remittance arrived on",
    ),
    document: entityOfType(SystemEntity.CORE_DOCUMENT)
      .optional()
      .describe(
        "The document being processed; its file name keeps the raw reference distinct per attachment",
      ),
  }),
  outputSchema: z.object({
    provenance: remittanceProvenanceSchema,
  }),
  configSchema: z.object({}),
  emits: [] as const,
});
